import { render } from "./BrandPortfolioWorkspaceNameCell.vue?vue&type=template&id=17fdc50f&scoped=true"
import script from "./BrandPortfolioWorkspaceNameCell.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioWorkspaceNameCell.vue?vue&type=script&lang=js"

import "./BrandPortfolioWorkspaceNameCell.vue?vue&type=style&index=0&id=17fdc50f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fdc50f"]])

export default __exports__